import { InternalDateFirstDayWeek, InternalDateOrder, InternalDateSeparator } from "../types";
export var MIN_YEAR = 0;
export var MAX_YEAR = 9999;
export var MIN_MONTH = 1;
export var MAX_MONTH = 12;
export var MIN_DATE = 1;
export var MAX_DATE = 31;
export var MIN_FULLDATE = '01.01.1900';
export var MAX_FULLDATE = '31.12.2099';
export var LENGTH_YEAR = 4;
export var LENGTH_MONTH = 2;
export var LENGTH_DATE = 2;
export var LENGTH_SEPARATOR = 1;
export var LENGTH_FULLDATE = LENGTH_YEAR + LENGTH_MONTH + LENGTH_DATE + LENGTH_SEPARATOR * 2;
export var CHAR_PAD = '0';
export var CHAR_MASK = '_';
export var SEPARATOR = "(?:\\.|\\/|\\-|\\s|\\,)";
export var RE_ORDER_MDY = new RegExp("^(\\d{1," + LENGTH_MONTH + "})?" + SEPARATOR + "?(\\d{1," + LENGTH_DATE + "})?" + SEPARATOR + "?(\\d{1," + LENGTH_YEAR + "})?$");
export var RE_ORDER_DMY = new RegExp("^(\\d{1," + LENGTH_DATE + "})?" + SEPARATOR + "?(\\d{1," + LENGTH_MONTH + "})?" + SEPARATOR + "?(\\d{1," + LENGTH_YEAR + "})?$");
export var RE_ORDER_YMD = new RegExp("^(\\d{1," + LENGTH_YEAR + "})?" + SEPARATOR + "?(\\d{1," + LENGTH_MONTH + "})?" + SEPARATOR + "?(\\d{1," + LENGTH_DATE + "})?$");
export var emptyDateComponents = {
  year: null,
  month: null,
  date: null
};
export var defaultDateComponentsOrder = InternalDateOrder.DMY;
export var defaultDateComponentsSeparator = InternalDateSeparator.Dot;
export var defaultFirstDayWeek = InternalDateFirstDayWeek.Monday;